module.exports = __webpack_public_path__ + "static/img/step-09.6b6fab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-09.png
// module id = zpOP
// module chunks = 1